import React, { useEffect, useRef } from 'react'
//import PageLayout from '../display/page'
//import Prose from '../prose'
import './styles.css'

import { X } from 'react-feather'


const Paragraph__Dialog = ({ id = 'dialog-slice', title, body }) => {
    const dialog = useRef();

    useEffect(() => {
        document.querySelectorAll(`[href="#${id}"]`).forEach(trigger => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                dialog.current.showModal();
            });
        })
    }, [dialog.current]);

    return (
        <dialog ref={dialog} id={id} className="promotion--dialog">
            <button onClick={() => {
                dialog?.current?.close();
            }} type="button" className="w-10 h-10 absolute top-4 right-4 hover:text-primary outline-none focus-visible:text-orange">
                <X className="w-full h-full align-top" />
                <span className="sr-only">Close</span>
            </button>
            {title ? <h2>{title}</h2> : null}
            {body ? <div dangerouslySetInnerHTML={{__html: body.html}} /> : null}
        </dialog>
    )
}
export default Paragraph__Dialog